import { render, staticRenderFns } from "./Expired.vue?vue&type=template&id=2cd91073"
import script from "./Expired.vue?vue&type=script&lang=js"
export * from "./Expired.vue?vue&type=script&lang=js"
import style0 from "./Expired.vue?vue&type=style&index=0&id=2cd91073&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports